<template>
  <div class="edit-member-role">
    <Modal :mask-closable="false" title="修改角色" :value="visible" @on-visible-change="visibleChange" :width="650" style="position:relative">
      <CheckboxGroup v-model="selectRoles">
        <span v-for="role in roles" :key="role.id">
          <Checkbox :label="role.normalizedName" class="checkbox-item" :class="{'checked-item': selectRoles.indexOf(role.name) !== -1}">
            <span>{{role.displayName}}</span>
          </Checkbox>
        </span>
      </CheckboxGroup>
      <div slot="footer">
        <Button @click="cancel">取消</Button>
        <Button @click="editRole" type="primary">确定</Button>
      </div>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </Modal>
  </div>
</template>

<script>
import ajax from '../../../lib/userAjax'
export default {
  name: 'editMemberRole',
  data() {
    return {
      selectRoles: [],
      spinShow: false
    }
  },
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false
    },
    roles: {
      type: Array,
      default: () => {
        return []
      }
    },
    editInfo: {
      type: Object
    }
  },
  methods: {
    visibleChange(value) {
      if (!value) {
        this.selectRoles = []
        this.$emit('input', value);
      }
    },
    async editRole() {
      // let rep = ajax.post('/api/services/app/User/Update', )
      this.spinShow = true
      let data = []
      if (this.editInfo.type === 'single') {
        data.push({
          'userId': this.editInfo.editMember[0].id,
          'roleNames': this.selectRoles
        })
      }
      if (this.editInfo.type === 'batch') {
        this.editInfo.editMember.forEach(item => {
          let dataItem = {}
          dataItem.userId = item.id
          this.selectRoles.forEach(role => {
            if (item.roleNames.indexOf(role) === -1) {
              item.roleNames.push(role)
            }
          })
          dataItem.roleNames = item.roleNames
          data.push(dataItem)
        })
      }
      if (this.editInfo.type === 'batchRemove') {
        this.editInfo.editMember.forEach(item => {
          let dataItem = {}
          dataItem.userId = item.id
          this.selectRoles.forEach(role => {
            if (item.roleNames.indexOf(role) !== -1) {
              let index = item.roleNames.indexOf(role)
              item.roleNames.splice(index, 1)
            }
          })
          dataItem.roleNames = item.roleNames
          data.push(dataItem)
        })
      }
      try {
        let rep = await ajax.post('/api/services/app/User/BatchUpdateRoles', data)
        if (rep.data.success) {
          this.$Message.success('修改角色成功')
          this.$emit('finish')
        } else {
          this.$Message.success('修改角色失败')
        }
        this.spinShow = false
      } catch (err) {
        this.spinShow = false
      }
    },
    cancel() {
      this.$emit('input', false);
    }
  },
  watch: {
    editInfo(newVal) {
      if (newVal.type === 'single') {
        this.selectRoles = newVal.editMember[0]['roleNames']
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 修改checkbox样式
.checkbox-item {
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 5px;
  &:hover {
    border-color: #2d8cf0;
  }
}
.checked-item {
  border-color: #2d8cf0;
}
</style>
